import { render, staticRenderFns } from "./ProductResume.vue?vue&type=template&id=dbf6ebae&scoped=true"
import script from "./ProductResume.vue?vue&type=script&lang=js"
export * from "./ProductResume.vue?vue&type=script&lang=js"
import style0 from "./productResume.scss?vue&type=style&index=0&id=dbf6ebae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf6ebae",
  null
  
)

export default component.exports